export const blockIconsTransportationUTurnLeftNew = (
	<span className='material-symbols-outlined'>u_turn_left</span>
);
